var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.notificationModalState)?_c('notification-modal',{attrs:{"notification":_vm.notification,"isBaseModal":_vm.isBaseModal,"isPopupModal":_vm.isPopupModal},on:{"close":_vm.modalClose}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }